__turbopack_context__.v({
  "browser_fix": "styles-module-scss-module__tjZ2Sa__browser_fix",
  "button_wrapper": "styles-module-scss-module__tjZ2Sa__button_wrapper",
  "deleting_note": "styles-module-scss-module__tjZ2Sa__deleting_note",
  "header": "styles-module-scss-module__tjZ2Sa__header",
  "input_field": "styles-module-scss-module__tjZ2Sa__input_field",
  "input_label": "styles-module-scss-module__tjZ2Sa__input_label",
  "listing": "styles-module-scss-module__tjZ2Sa__listing",
  "modal_container": "styles-module-scss-module__tjZ2Sa__modal_container",
  "modal_content": "styles-module-scss-module__tjZ2Sa__modal_content",
  "note_form": "styles-module-scss-module__tjZ2Sa__note_form",
  "notes_content": "styles-module-scss-module__tjZ2Sa__notes_content",
  "save_note_container": "styles-module-scss-module__tjZ2Sa__save_note_container",
  "spinner": "styles-module-scss-module__tjZ2Sa__spinner",
});
